import config from '../constants/config';
const { serviceUrl, environment } = config;

// const b2bPath = '/api/store/b2b';
const proxiedServiceUrl =
  process.env.NODE_ENV === 'development'
    ? `http://localhost:3001/api?url=${serviceUrl}`
    : ''; // relative path if deployed

const paths = {
 goToSignIn: (params) => `${proxiedServiceUrl}${environment.services.cdcam.identity.login}?isSignInUrl=${params}`,
 goToRegistation: () => `${proxiedServiceUrl}${environment.services.cdcam.identity.registration}`,
 findFederated: () => `${proxiedServiceUrl}${environment.services.cdcam.identity.federation.find_federated}`,
 findRpUrls: () => `${proxiedServiceUrl}${environment.services.cdcam.identity.rpUrls}`,
 updatedNotificationLink: (uid) => `${proxiedServiceUrl}${environment.services.cdcam.identity.updatedNotificationLink}${uid}`,
 liteRegCheck: (userName) => `${proxiedServiceUrl}${environment.services.cdcam.identity.liteRegCheck}${userName}`,
 weChatEmailCheck: () =>`${proxiedServiceUrl}${environment.services.cdcam.weChat.loginID}`,
 weChatPasswordCheck: () =>`${proxiedServiceUrl}${environment.services.cdcam.weChat.authBind}`
};

export default paths;
